
import { Action, Component, Getter, namespace, Vue } from 'bits/vue'
import BookmarksModal from 'vuecomponents/BookmarksModal.vue'

const collectionsStore = namespace('wallCollections')

@Component({
  components: {
    BookmarksModal,
  },
})
export default class SurfaceEditBookmarkModal extends Vue {
  @Getter xEditBookmarksDialog!: boolean
  @Getter editBookmarksDialogPopoverAnchor!: boolean
  @Action promptNameForNewFolder!: () => void
  @Action closeEditBookmarksDialog!: () => void
  @Action genericFetchError!: ({ error }) => void
  @collectionsStore.Getter activeWallId
  @collectionsStore.Getter activeUserFolders
  @collectionsStore.Getter activeWallFolderIds
  @collectionsStore.Getter isActiveWallInFavorites
  @collectionsStore.Action addBookmark
  @collectionsStore.Action removeBookmark

  handleError(error): void {
    this.genericFetchError({ error })
  }
}
